import { useState } from "react";
import { Helmet } from "react-helmet";
import { Modal, Spinner } from "react-bootstrap";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import axios from "axios";
import "./auditor.css";
import AuditorForm from "./auditor-form";

function Auditor() {
  const [masterValue, setMasterValue] = useState("");
  const [masterData, setMasterData] = useState(null);
  const [loanding, setLoanding] = useState(false);
  const [view, setView] = useState("input");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Solo permite dígitos

    if (value.length > 11) {
      value = value.slice(0, 11); // Máximo 11 dígitos (3 + 8)
    }

    if (value.length > 3) {
      value = value.slice(0, 3) + "-" + value.slice(3); // Agrega el guión automáticamente
    }

    setMasterValue(value);
    setError(""); // Limpia el error mientras escriben
  };

  const handleSearch = async () => {
    const regex = /^\d{3}-\d{8}$/;

    if (!masterValue.trim()) {
      setError("Este campo es obligatorio");
      return;
    }

    if (!regex.test(masterValue)) {
      setError("Formato de master invalido");
      return;
    }
    setLoanding(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_auditor/audit`,
        { awb: masterValue },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setMasterData(res.data.data);
        setView("forms");
        setLoanding(false);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title:
          error.response?.data?.message ||
          "La master no existe favor de verificar",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
    setLoanding(false);
  };

  return (
    <>
      <Helmet>
        <title>Horus | Auditor</title>
      </Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" class="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                value={masterValue}
                onChange={handleInputChange}
              />
              {error && <small className="text-danger">{error}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                {!loanding && (
                  <button className="btnn" onClick={handleSearch}>
                    Buscar
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {view === "forms" && (
          <AuditorForm
            master={masterData}
            setLoanding={setLoanding}
            loanding={loanding}
          />
        )}
      </div>

      <Modal
        show={loanding}
        onHide={() => {
          setLoanding(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Auditor;
